<template>
  <section>
    <div class="available-soon" v-if="noItemsAvailable && !isLoaderActive">
      <img :src="itemContent.mainImg" />
      <p>{{ t(itemContent.mainText) }}</p>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import signalssImage from "@/assets/images/components/noAvailableItems/signals.svg";
import newsImage from "@/assets/images/components/noAvailableItems/news.svg";
import webinarsImage from "@/assets/images/components/noAvailableItems/webinars.svg";
import ebooksImage from "@/assets/images/components/noAvailableItems/ebooks.svg";

export default {
  name: "availableSoon",
  props: ["noItemsAvailable", "itemType"],
  computed: {
    ...mapGetters(["t", "isLoaderActive"]),
    itemContent: function() {
      let mainText = "";
      let mainImg = "";
      switch (this.itemType) {
        case "signals":
          mainText = "No_signals_available";
          mainImg = signalssImage;
          break;
        case "news":
          mainText = "No_news_available";
          mainImg = newsImage;
          break;
        case "webinars":
          mainText = "No_webinars_available";
          mainImg = webinarsImage;
          break;
        case "ebooks":
          mainText = "ebook_no_available";
          mainImg = ebooksImage;
          break;
        default:
          break;
      }
      return { mainText, mainImg };
    }
  }
};
</script>

<style lang="scss" scoped>
.available-soon {
  display: flex;
  height: 85vh;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  img {
    //margin-bottom: 44px;
    margin-bottom: 38px;
  }

  p {
    font-size: 1.25rem;
    font-weight: bold;
    color: #9e9e9e;
    text-align: center;
  }
}

@media (max-width: 768px) {
  .available-soon {
    height: 85vh;
    //svg{
    //  margin-bottom: 43px;
    //}
  }
}
</style>
